import { useState, useMemo } from "react";
import type { StringOptions } from "../../../../components/Select/types";

export const ALL_YEARS_VALUE = "all";

const ALL_YEARS_OPTION: StringOptions = {
  value: ALL_YEARS_VALUE,
  label: "All years",
};

export function useYearFilter(availableYears: number[]) {
  const [selectedYear, setSelectedYear] = useState<number | null>(null);

  const yearOptions = useMemo(
    () => [
      ALL_YEARS_OPTION,
      ...availableYears.map((y) => ({ value: String(y), label: String(y) })),
    ],
    [availableYears],
  );

  const selectedYearOption = useMemo(
    () =>
      selectedYear === null
        ? ALL_YEARS_OPTION
        : (yearOptions.find((o) => o.value === String(selectedYear)) ?? null),
    [selectedYear, yearOptions],
  );

  const handleYearChange = (opt: unknown) => {
    if (opt) {
      const { value } = opt as StringOptions;
      setSelectedYear(value === ALL_YEARS_VALUE ? null : Number(value));
    }
  };

  return {
    selectedYear,
    yearOptions,
    selectedYearOption,
    handleYearChange,
  };
}
